import React from 'react';
import { Modal as CoreModal } from '@byscott-io/corebyscott';

// This app's historical size scale differs from core's; map it so existing
// call sites keep their widths while inheriting the shared Modal styling
// (subtle backdrop, draggable header).
const SIZE_MAP = { sm: 'md', md: 'lg', lg: 'xl', xl: '4xl' };

export default function Modal({ isOpen, onClose, title, children, size = 'md' }) {
  return (
    <CoreModal open={!!isOpen} onClose={onClose} title={title} size={SIZE_MAP[size] || 'lg'}>
      {children}
    </CoreModal>
  );
}
